module.exports = __webpack_public_path__ + "6817b38420a5ec025fe0de8180588da4.svg";